import styled from 'styled-components';

import { IInspectionList } from './InspectionList';

export const TopTabContainer = styled.div`
  display: flex;
  gap: 16px;
  overflow-x: scroll;
  scroll-behavior: smooth;
  padding-inline: 16px;

  ::-webkit-scrollbar {
    height: 0;
  }
`;

export const TopTab = styled.div<IInspectionList.IHeader>`
  display: inline-block;
  white-space: nowrap;
  padding-bottom: 2px;
  border-bottom: ${({ isSelected, theme }) =>
      isSelected ? `${theme.colors.primaryGreen500}` : 'transparent'}
    2px solid;

  label {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 12px;
    color: ${({ isSelected, theme }) =>
      isSelected ? theme.colors.primaryGreen500 : theme.colors.gray0};
    text-shadow: 0 1px 2px rgba(12, 187, 114, 0.21);
  }
`;

export const Content = styled.div<{ isHidden?: boolean }>`
  display: ${({ isHidden }) => (isHidden ? 'none' : 'flex')};
  flex-direction: column;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.colors.gray900};
  flex: 1;
  margin: 108px 0 0 0; ;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 12px 108px 12px;
  gap: 12px;
`;
